<template>
  <div>
    <b-row>
      <b-col sm="8">
        <BogiEditor :answer="item" :content="initText" :func="updateText" />
      </b-col>
      <b-col sm="2" v-if="flag == '1'">
        <b-select v-model="item.strt" :options="SSub_Sub"></b-select>
      </b-col>

      <b-col>
        <b-button @click="remove" variant="danger" size="sm">D</b-button>
      </b-col>
    </b-row>
    <b-row style="margin-bottom: 5px">
      <b-col v-if="flag == '2'">
        <b-input placeholder="해석" v-model="item.strt" />
      </b-col>
    </b-row>

    <div class="multisel_wrapper" v-show="flag == '1' || flag == '3'">
      <multiselect
        v-model="item.intent"
        :options="intent_options"
        :custom-label="nameWithLang"
        placeholder="출제포인트(필수)"
        label="name"
        track-by="name"
        @select="chgval"
      ></multiselect>
    </div>
    <hr />
  </div>
</template>

<script>
import * as R from "ramda";
import { mapActions, mapState } from "vuex";
import BogiEditor from "@/components/BogiEditor";
import Multiselect from "vue-multiselect";
const senStore = "senStore";
export default {
  props: ["item"],
  components: { BogiEditor, Multiselect },
  computed: {
    ...mapState(senStore, [
      "flag",
      "ays_answers",
      "comt_answers",
      "shuffle_answers",
      "SSub",
      "senintent_options",
    ]),
    intent_options() {
      return this.senintent_options;
    },
    SSub_Sub() {
      let $this = this;


      // bug: when strt value have '전목', there are some duplicated values with  '전'
      let k = R.filter((f) => {
        if (f.value.indexOf($this.item.strt) >= 0) {
          if($this.item.strt === "전" &&  f.value.indexOf("전목") >= 0 ){
            return false;
          }

          if($this.item.strt === "O" &&  f.value.indexOf("IO") >= 0 ){
            return false;
          }
          if($this.item.strt === "O" &&  f.value.indexOf("DO") >= 0 ){
            return false;
          }


          return true;
        } else if ($this.item.strt === "S" && f.value.indexOf("주어") >= 0) {
          return true;
        } else if ($this.item.strt === "O" && f.value.indexOf("목적어") >= 0) {
          return true;
        } else {
          return false;
        }
      }, this.SSub);
      return k;
    },
  },
  data() {
    return {
      myf: "",
      initText: this.item.text,
    };
  },
  methods: {
    ...mapActions(senStore, [
      "AC_AYS_ANSWER_EXCHAGE",
      "AC_COMT_ANSWER_EXCHAGE",
      "AC_SHUFFLE_ANSWER_EXCHAGE",
    ]),
    nameWithLang({ d1, d2, d3 }) {
      return `${d1} -> ${d2} -> ${d3}`;
    },

    remove() {
      if (confirm("삭제하시겠습니까?")) {
        if (this.flag == "1") {
          let excd = R.filter((k) => {
            return k.id != this.item.id;
          }, this.ays_answers);

          let withIndexed = R.addIndex(R.map);

          excd = withIndexed((item, idx) => {
            item.id = idx + 1 + "";
            return item;
          }, excd);

          console.log(excd);

          this.AC_AYS_ANSWER_EXCHAGE(excd);
        } else if (this.flag == "2") {
          let excd = R.filter((k) => {
            return k.id != this.item.id;
          }, this.comt_answers);

          let withIndexed = R.addIndex(R.map);

          excd = withIndexed((item, idx) => {
            item.id = idx + 1 + "";
            return item;
          }, excd);

          this.AC_COMT_ANSWER_EXCHAGE(excd);
        } else if (this.flag == "3") {
          let excd = R.filter((k) => {
            return k.id != this.item.id;
          }, this.shuffle_answers);

          let withIndexed = R.addIndex(R.map);

          excd = withIndexed((item, idx) => {
            item.id = idx + 1 + "";
            return item;
          }, excd);
          this.AC_SHUFFLE_ANSWER_EXCHAGE(excd);
        }
      }
    },
    updateText(txt) {
      console.log(txt);
    },
    chgval(query) {
      //첫번째 attribute 인지 확인필요
      //첫번째이면 나머지 row의 intent 적용

      let withIndex = R.addIndex(R.map);
      let pos = -1;
      let $this = this;
      // console.log(this.item);
      if (this.flag == "1") {
        withIndex((item, idx) => {
          if (item.id == $this.item.id) {
            pos = idx;
          }
          return item;
        }, this.ays_answers);

        // alert(pos);
        if (pos == 0) {
          console.log(this.item.intent);
          this.ays_answers = R.map((item) => {
            item.intent = query;
            return item;
          }, this.ays_answers);

          console.log(this.item);
          // 나머지의 intent도 변경한다.
        }
      } else if (this.flag == "2") {
        withIndex((item, idx) => {
          if (item.id == $this.item.id) {
            pos = idx;
          }
          return item;
        }, this.comt_answers);

        // alert(pos);
        if (pos == 0) {
          this.comt_answers = R.map((item) => {
            item.intent = query;
            return item;
          }, this.comt_answers);

          // 나머지의 intent도 변경한다.
        }
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.senans_wrapper {
  display: flex;
  input {
    margin-right: 15px;
    width: 200px;
  }
}
.multiselect--active {
  z-index: 10;
}
.multiselect__content-wrapper {
  z-index: 10;
}
</style>